import { AfterViewChecked, AfterViewInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownItem } from '../../models/commonModel';
@Component({
  selector: 'app-addresstabs',
  templateUrl: './addresstabs.component.html',
  styleUrls: ['./addresstabs.component.scss'],
})
export class AddresstabsComponent implements OnInit {
  @Input()
  AddressTab!: FormGroup;
  @Input()
  IsMailingAddressTab: boolean = false;
  @Input()
  CountryTypes!: DropdownItem[];
  @Input()
  StateTypes!: DropdownItem[];

  constructor(private formBuilder: FormBuilder) {
   
  }

  ngOnInit(): void {}
}
